import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import CryptoJs from "crypto-js";
export default {
  //加密
  encrypt: function encrypt(word) {
    var keyStr = "7894651784ASDJKH"; //判断是否存在欤ey,不存在姚用定义好欲ey
    var key = CryptoJs.enc.Utf8.parse(keyStr);
    var srcs = CryptoJs.enc.Utf8.parse(word);
    var encrypted = CryptoJs.AES.encrypt(srcs, key, {
      mode: CryptoJs.mode.ECB,
      padding: CryptoJs.pad.Pkcs7
    });
    return encrypted.toString();
  },
  //加密
  decrypt: function decrypt(word) {
    var keyStr = "7894651784ASDJKH"; //判断是否存在欤ey,不存在姚用定义好欲ey
    var key = CryptoJs.enc.Utf8.parse(keyStr);
    var decrypt = CryptoJs.AES.decrypt(word, key, {
      mode: CryptoJs.mode.ECB,
      padding: CryptoJs.pad.Pkcs7
    });
    return CryptoJs.enc.Utf8.stringify(decrypt).toString();
  }
};